export default "__VITE_ASSET__5948eb0f__"